var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.18758 191.4059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1035"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6cdd0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8fafb",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1027"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0967b6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f4d8f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1009"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#818a92",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65717b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1011",
    href: "#linearGradient1009",
    x1: 523.25903,
    y1: 396.98996,
    x2: 523.25903,
    y2: 1078.8429,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1029",
    href: "#linearGradient1027",
    x1: 66.798416,
    y1: 317.88858,
    x2: 119.18324,
    y2: 367.86798,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1037",
    href: "#linearGradient1035",
    x1: 90.852669,
    y1: 296.77429,
    x2: 90.852669,
    y2: 390.58588,
    gradientUnits: "userSpaceOnUse"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.4994383,-247.26579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 895.63749,348.35117 c -36.14454,-2.71975 -16.12219,57.67342 -124.22067,74.13675 -93.53871,-0.86736 -97.83817,-52.80203 -119.3883,-69.07933 -14.71,-11.1108 -45.28026,2.75447 -86.96797,27.90391 -38.39755,23.9073 -49.4755,36.85235 -50.96048,46.98228 -2.46373,16.80653 15.26719,24.25958 18.79005,55.23163 1.8859,16.58034 6.18601,39.90077 -13.34986,75.00446 -22.67112,40.73736 -42.06832,49.10293 -59.34347,57.24955 -53.70448,25.32595 -75.45327,-42.35446 -82.63624,102.40122 -6.2648,126.25215 26.52928,54.20356 82.52272,80.98122 15.07939,7.21139 35.12044,12.22134 52.60423,41.43089 98.3805,164.36085 -98.07932,104.52107 62.86133,208.40235 105.45081,66.3384 88.34114,-53.20079 173.57617,-55.81641 191.53092,-3.01958 41.47601,137.19971 211.91016,49.76171 31.15156,-13.8092 47.84794,-30.7472 54.46194,-41.912 5.6865,-9.59918 3.6568,-13.21842 -0.01,-26.67815 -7.8168,-28.72513 -27.75221,-72.71352 -8.4307,-106.60985 93.1504,-155.68283 131.9812,30.01826 141.4747,-161.66913 -0.7235,-38.415 -2.0828,-63.46444 -11.7041,-73.11482 -9.9565,-9.98656 -28.4742,-3.98376 -46.9677,-9.5524 -16.6211,-5.00482 -47.6741,-11.64702 -61.808,-35.20116 -98.28874,-165.27834 85.7412,-132.15609 -77.50852,-212.94608 -33.70398,-16.67962 -44.5852,-26.12978 -54.90939,-26.90664 z",
    transform: "matrix(0.26458333,0,0,0.26458333,-107.19405,155.12143)",
    fill: "url(#linearGradient1011)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 95.589844,292.04297 c -27.725647,0 -50.554688,22.82904 -50.554688,50.55469 0,27.72564 22.829041,50.55468 50.554688,50.55468 27.725646,0 50.554686,-22.82904 50.554686,-50.55468 0,-27.72565 -22.82904,-50.55469 -50.554686,-50.55469 z m 0,32.88476 c 9.953816,0 17.669926,7.71611 17.669926,17.66993 0,9.95381 -7.71611,17.66992 -17.669926,17.66992 -9.953815,0 -17.669922,-7.71611 -17.669922,-17.66992 0,-9.95382 7.716107,-17.66993 17.669922,-17.66993 z",
    fill: "url(#linearGradient1037)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 129.70252,342.5976 c 0,18.83973 -15.27262,34.11235 -34.112348,34.11235 -18.839731,0 -34.112351,-15.27262 -34.112351,-34.11235 0,-18.83974 15.27262,-34.11236 34.112351,-34.11236 18.839728,0 34.112348,15.27262 34.112348,34.11236 z",
    fill: "url(#linearGradient1029)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinSettings);
export default __webpack_public_path__ + "static/media/winSettings.291743aee0319a3612255c608e54a5a5.svg";
export { ForwardRef as ReactComponent };